import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiAlertsComponent } from '@components/ui-alerts/ui-alerts.component';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';

@NgModule({
    imports: [
        A11yModule,
        CommonModule,
        RouterModule,
        ComponentSharedModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatTooltipModule,
        MatButtonModule,
        UiDateFormatModule,
    ],
    declarations: [
        UiAlertsComponent,
    ],
    exports: [
        UiAlertsComponent,
    ],
})
export class UiAlertModule { }
